"use client";

import { Translation } from "@/components/Translation/Translation.component";
import { useSite } from "@/contexts/site/site.context";
import { inlineJsx } from "@/ts/locale/inline-jsx";
export function CommentsGuidelines() {
  const {
    brand: {
      link
    },
    domain
  } = useSite();
  const brandHostname = link ? new URL(link).hostname : null;
  if (brandHostname === domain) {
    return null;
  }
  const guidelinesLink = <a className="text-primary underline" href={`${link}/service/debate-guidelines`} rel="noopener noreferrer" target="_blank">
      <Translation da="her" de="hier" en="here" no="her" sv="här" />
    </a>;
  return <p className="mt-1 text-dim text-sm">
      <Translation da={inlineJsx`Du er velkommen til at kommentere artiklen. Læs vores retningslinjer ${guidelinesLink}.`} de={inlineJsx`Sie sind herzlich eingeladen, den Artikel zu kommentieren. Lesen Sie unsere Richtlinien ${guidelinesLink}.`} en={inlineJsx`You are welcome to comment on the article. Read our guidelines ${guidelinesLink}.`} no={inlineJsx`Du er velkommen til å kommentere artikkelen. Les våre retningslinjer ${guidelinesLink}.`} sv={inlineJsx`Du är välkommen att kommentera artikeln. Läs våra riktlinjer ${guidelinesLink}.`} />
    </p>;
}